import AtendimentosAuxiliaresIndex from "@/Pages/AtendimentosAuxiliares/index.vue";
import NewEditAtendimentoPage from "@/Pages/AtendimentosAuxiliares/NewEditAtendimentoPage.vue";
import NewEditPeiPage from "@/Pages/Pei/NewEditPeiPage.vue";
import Index from "@/Pages/GestaoDeAulasAuxiliares/index.vue";
import NewCreateGestaoDeAuxiliares from "@/Pages/GestaoDeAulasAuxiliares/NewCreateGestaoDeAuxiliares.vue";
import relatorioAuxiliares from "@/Pages/GestaoDeAulasAuxiliares/relatorioAuxiliares.vue";

export default [
  {
    path: "/gestoes-de-aulas-auxiliares",
    name: "gestoesDeAulasAuxiliares",
    component: Index,
  },
  {
    path: "/gestoes-de-aulas-auxiliares-create",
    name: "gestoesDeAulasAuxiliares.newEdit",
    component: NewCreateGestaoDeAuxiliares,
    props: { editing: false },
  },
  {
    path: "/gestoes-de-aulas-auxiliares/edit/:gestaoDeAulasId",
    name: "gestoesDeAulasAuxiliares.edit",
    component: NewCreateGestaoDeAuxiliares,
    props: { editing: true },
  },
  {
    path: "/gestoes-de-aulas-auxiliares-relatorio/:gestaoId",
    name: "gestoesAuxiliaresRelatorio.newEdit",
    component: relatorioAuxiliares,
  },
  // Diário de Auxiliares de 2026 em diante (#7286). As rotas acima continuam servindo
  // anos anteriores e não devem ser alteradas.
  {
    path: "/diario-auxiliares/:gestaoId/relatorios-diarios",
    name: "atendimentosAuxiliares",
    component: AtendimentosAuxiliaresIndex,
    props: true,
  },
  {
    path: "/diario-auxiliares/:gestaoId/relatorios-diarios/create",
    name: "atendimentosAuxiliares.create",
    component: NewEditAtendimentoPage,
    props: (route) => ({ ...route.params, editing: false }),
  },
  {
    path: "/diario-auxiliares/:gestaoId/relatorios-diarios/:atendimentoId/edit",
    name: "atendimentosAuxiliares.edit",
    component: NewEditAtendimentoPage,
    props: (route) => ({ ...route.params, editing: true }),
  },
  {
    path: "/diario-auxiliares/:gestaoId/relatorios-diarios/:atendimentoId",
    name: "atendimentosAuxiliares.view",
    component: NewEditAtendimentoPage,
    props: (route) => ({ ...route.params, somenteLeitura: true }),
  },
  {
    path: "/diario-auxiliares/:gestaoId/pei/:bimestre",
    name: "peis.lancar",
    component: NewEditPeiPage,
    props: true,
  },
];
